import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { user, loading } = useAuth();

  // While auth initializes, avoid redirecting — show nothing or a loader
  if (loading) {
    return <div className="flex h-full w-full items-center justify-center">Loading...</div>;
  }

  if (!user || !user.isAuthenticated) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;